module.exports = __webpack_public_path__ + "img/victoria_maraia_1.a5645107.jpg";